import React from 'react';
import Panel from '../components/Panel';
import auth from '../lib/auth';
import helpers from '../lib/helpers';
import store, {actions} from '../store';
import InputSelect from '../components/InputSelect';
import _ from 'lodash';
import Input from '../components/Input';
import {Alert} from 'reactstrap';

export default class ManageGroups extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
      data: {},
      submitting: false,
      fetching: false,
      saved: false,
      deleting: false,
      deleted: false,
    };

    this.user = {};

    this.handleGroupSelect = this.handleGroupSelect.bind(this);
    this.handleMemberSelect = this.handleMemberSelect.bind(this);
    this.handleBlueprintTypeChange = this.handleBlueprintTypeChange.bind(this);
    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
  }

  async componentDidMount() {
    let [user, users, groups] = await Promise.all([
      auth.user(),
      store.dispatch(actions.users.fetchAll()),
      store.dispatch(actions.groups.fetchAll()),
    ]);

    _.forEach(groups, (group) => {
      if (_.isArray(group.users)) {
        _.forEach(users, (user) => {
          if (group.users.includes(user.userId)) {
            if (!user.groups) {
              user.groups = [];
            }
            user.groups.push(group);
          }
        });
      }
    });

    this.user = user;

    this.setState({
      initializing: false,
      user,
      users,
      groups,
    });
  }

  save() {
    this.setState({
      submitting: true,
    });

    let data = Object.assign({}, this.state.data);
    data.users = _.map(data.users || [], (user) => user.userId);
    data.blueprintType = data.blueprintType || 'wl';

    store.dispatch(actions.groups.createOrUpdate(data)).
        then((result) => {
          /*
            There is a bug on the API where the result.users is an object (specifically, AWS object)
            and not an array.
           */
          result.users = _.map(result.users ? result.users.values : [], (userId) => {
            return _.find(this.state.users, (user) => {
              return user.userId === userId;
            });
          });
          if (this.state.data.groupId) {
            this.setState({
              saved: true,
              submitting: false,
              groups: _.map(this.state.groups, (group) => {
                if (this.state.data.groupId ===
                    group.groupId) return this.state.data;
                return group;
              }),
            });
          } else {
            this.setState({
              data: result,
              submitting: false,
              saved: true,
              groups: this.state.groups.push(result),
            });
          }

          setTimeout(() => {
            this.setState({
              saved: false,
            });
          }, 3000);
        }).
        catch(err => {
          this.setState({
            submitting: false,
          });
          alert(err.message);
          console.error(err);
        });
  }

  remove() {
    if (!window.confirm(
        `Are you sure want to remove '${this.state.data.groupName}'`)) {
      return;
    }
    this.setState({
      deleting: true,
    });

    store.dispatch(actions.groups.remove(this.state.data.groupId)).
        then(result => {
          this.setState({
            deleted: true,
            deleting: false,
            groups: _.filter(this.state.groups, (group) => {
              return (this.state.data.groupId !==
                  group.groupId);
            }),
            data: {},
          });
          setTimeout(() => {
            this.setState({
              deleted: false,
            });
          }, 3000);
        }).
        catch(err => {
          alert(err.message);
          this.setState({
            deleting: false,
          });
        });
  }

  handleGroupSelect(data) {

    if (!_.isObject(data)) {
      this.setState({
        data: {
          blueprintType: 'wl'
        },
      });
    } else if (_.isObject(data.value)) {
      this.setState({
        fetching: true,
        data: {blueprintType: 'wl'},
      });
      let group = data.value;
      store.dispatch(actions.groups.fetch(group.groupId)).then((result) => {
        result.users = _.filter(_.map(result.users || [], (userId) => {
          return _.find(this.state.users, (user) => {
            return user.userId === userId;
          });
        }),(user) => !!user);
        result.blueprintType = result.blueprintType || 'wl';
        this.setState({
          fetching: false,
          data: result,
        });
      }).catch(err => {
        alert(err.message);
        this.setState({
          fetching: false,
        });
      });
    } else if (_.isString(data.value)) {
      this.setState({
        data: {
          groupName: data.value,
          blueprintType: 'wl'
        },
      });
    }
  }

  handleBlueprintTypeChange(value) {
    this.setState({
      data: Object.assign({}, this.state.data, {
        blueprintType: value,
      }),
    });
  }

  handleMemberSelect(data) {
    this.setState({
      data: Object.assign({}, this.state.data, {
        users: _.map(data, (item) => item.value),
      }),
    });
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() :
        !this.user.isAdmin ? helpers.showPageNotFound() : (
            <Panel title="Manage Groups">
              <Alert color="success" isOpen={this.state.saved}>
                Group Saved
              </Alert>
              <Alert color="info" isOpen={this.state.deleted}>
                Group Deleted
              </Alert>
              <InputSelect
                  label="Group Name"
                  placeholder={this.state.fetching ?
                      'Fetching...' :
                      'New Group or Select Existing'}
                  options={_.map(this.state.groups, (group) => {
                    return {label: group.groupName, value: group};
                  })}
                  onChange={this.handleGroupSelect}
                  creatable
                  value={this.state.data.groupName ?
                      {
                        label: this.state.data.groupName,
                        value: this.state.data.groupName,
                      } :
                      null}
                  promptTextCreator={(label) => `Create group '${label}'`}
              />
              <InputSelect
                  label="Blueprint Type"
                  disabled={!this.state.data.groupName}
                  value={this.state.data.groupName ? (this.state.data.blueprintType || 'wl') : null}
                  simpleValue
                  clearable={false}
                  options={[
                    {label: 'White Label Only',value:'wl'},
                    {label: 'White Label and API',value:'wlapi'},
                    {label: 'API Only',value:'api'},
                  ]}
                  onChange={this.handleBlueprintTypeChange}
              />
              <InputSelect
                  disabled={!this.state.data.groupName}
                  label="Members"
                  placeholder="Select Group Members"
                  options={_.map(this.state.users, (user) => {
                    return {label: user.email, value: user};
                  })}
                  value={_.map(this.state.data.users || [], (user) => {
                    console.log([this.state.data,user])
                    return {label: user.email, value: user};
                  })}
                  onChange={this.handleMemberSelect}
                  multi
              />
              <div className="container-fluid clearfix" style={{
                borderTop: '1px solid #ccc',
                padding: '30px 60px 10px',
                margin: '0 -20px',
                width: 'auto',
              }}>
                <button className="btn btn-outline-danger pull-left px-5"
                        disabled={this.state.submitting ||
                        !this.state.data.groupId || this.state.deleting}
                        onClick={this.remove}
                >
                  {this.state.deleting ? 'Deleting...' : 'Delete'}
                </button>
                <button className="btn btn-purple pull-right px-5"
                        disabled={this.state.submitting ||
                        !this.state.data.groupName || this.state.deleting}
                        onClick={this.save}
                >
                  {this.state.submitting ?
                      'Saving...' :
                      (this.state.data.groupName ? 'Save' : 'Create')}
                </button>
              </div>
            </Panel>
        );
  }
}


// WEBPACK FOOTER //
// ./src/containers/ManageGroups.js